import React, { useEffect, useState } from "react";
import "./footer.css";
import { FaInstagram, FaFacebookF, FaTwitter, FaYoutube } from "react-icons/fa";
import { Navigate, useNavigate } from "react-router-dom";
import axiosConfig from "../../Services/axiosConfig";

function Footer() {
    let navigate = useNavigate();
    const [categories, setCategories] = useState([]);

    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    const categoryChunks = categories.length > 0 ? chunkArray(categories, 6) : [[]];

    const getCategories = async () => {
        try {
            const response = await axiosConfig.get(
                "/catlog/categories/?page_size=30&is_suspended=false"
            );
            setCategories(response.data.results || []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getCategories();
    }, []);

    return (
        <footer className="footer-container">
            <div className="footer-top">
                <div className="footer-brand">
                    <img src={localStorage.getItem("siteLogo")} alt="Furlenco Logo" className="footer-logo" onClick={() => navigate("/")} />
                    <div className="footer-socials">
                        <FaInstagram />
                        <FaFacebookF />
                        <FaTwitter />
                        <FaYoutube />
                    </div>
                </div>

                {categoryChunks.map((chunk, chunkIndex) => (
                    <div className="footer-links" key={chunkIndex}>
                        <h4 style={{ fontSize: "16px", marginBottom: "12px", color: "#333", marginTop: "0", visibility: chunkIndex === 0 ? "visible" : "hidden" }}>CATEGORIES</h4>
                        {chunk.map((item, index) => (
                            <div key={index} onClick={() => { navigate(`/${item.slug}`); window.scrollTo({ top: 0, behavior: "smooth" }) }}>
                                {item.name}
                            </div>
                        ))}
                    </div>
                ))}



                <div className="footer-help">
                    <h4>NEED HELP?</h4>
                    <button className="help-btn">HELP CENTER</button>
                </div>
            </div>

            <div className="footer-bottom">
                <p>We deliver to:</p>
                <div className="footer-cities">
                    Bengaluru, Mumbai, Pune, Delhi, Gurugram, Noida, Hyderabad, Chennai, Ghaziabad, Faridabad, Jaipur, Mysuru, Chandigarh, Vijayawada, Nashik, Sonipat, Patiala, Meerut, Panipat, Ambala, Karnal, Hisar, Kolkata, Ahmedabad, Coimbatore, Gandhinagar, Lucknow, Indore
                </div>
                <div className="footer-apps">
                    <img src="/google-play.png" alt="Google Play" />
                    <img src="/app-store.png" alt="App Store" />
                </div>
            </div>
        </footer>
    );
}

export default Footer;
